import React from 'react';
import styles from './MileageAnalysisTab_bus.module.css';

const MileageInsightsCard = ({ vehicleData, filterData }) => {
  // Mock data - replace with actual data from props
  const insights = [
    {
      id: 1,
      text: "",
      type: "info"
    },
    {
      id: 2,
      text: "",
      type: "success"
    },
    {
      id: 3,
      text: "",
      type: "warning"
    },
    {
      id: 4,
      text: "",
      type: "error"
    },
    {
      id: 5,
      text: "",
      type: "error"
    },
    {
      id: 6,
      text: "",
      type: "error"
    },
    {
      id: 7,
      text: "",
      type: "error"
    },
    {
      id: 8,
      text: "",
      type: "error"
    },
    {
      id: 9,
      text: "",
      type: "error"
    },
    {
      id: 10,
      text: "",
      type: "error"
    }
  ];

  // Always render the insights card
  return (
    <div className={`p-4 rounded ${styles.insightsCard}`}>
      {/* Header */}
      <div className="mb-3">
        <h5 className={`fw-bold mb-0 ${styles.insightsHeader}`}>
          Insights on Improving Mileage
        </h5>
      </div>
      
      {/* Insights List */}
      <div className="insights-content">
        <ul className={`mb-0 ${styles.insightsList}`}>
          {insights.map((insight) => (
            <li
              key={insight.id}
              className={`mb-2 ${styles.insightItem}`}
            >
              {insight.text}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MileageInsightsCard;